export default "__VITE_ASSET__bff24b74__"